import { isValidNumber } from '@/utils/number';

export const MAX_GROSS_MARGIN_PERCENTAGE = 100;
export const MIN_PRICE_IN_MICROS = 0;

export const isValidGrossMarginPercentage = (
  value: number | null | undefined,
): value is number => {
  return isValidNumber(value) && value < MAX_GROSS_MARGIN_PERCENTAGE;
};

export const isValidPriceInMicros = (
  value: number | null | undefined,
): value is number => {
  return isValidNumber(value) && value >= MIN_PRICE_IN_MICROS;
};
